/**
 * 0 pads hours and minutes
 *
 * @param literals
 * @param substitutions
 * @returns
 */
export function padHoursAndMinutes(literals: TemplateStringsArray, ...substitutions: any[]) {
  let result = '';

  for (let i = 0; i < substitutions.length; i++) {
    result += literals[i];
    result += `${parseInt(substitutions[i], 10) || 0}`.padStart(2, '0');
  }

  result += literals[literals.length - 1];

  return result;
}
